// @flow
import type { ActionsState } from '~/core/state/actions/types';
import type { ConnectProps } from './types';

import { connect } from 'react-redux';
import { curry, flowRight } from 'lodash/fp';
import { getAttributeDefinition } from '~/core/constants/actions';
import { getIconLocaleSuffix } from '~/core/state/config/selectors';
import { getIsHubNano1 } from '~/core/state/devices/selectors';
import { eventsByGroup, listDevicesForActionAttribute, newActionEvent } from '~/core/state/actions/selectors';
import {
    addActionAttribute,
    removeActionAttribute,
    setActionAttribute,
    setActionForm
} from '~/core/state/actions/actions';
import Component from './component';

const mapStateToProps = (state: { actions: ActionsState }, { extendedForm }: ConnectProps) => {
    const region = getIconLocaleSuffix(state);
    const isNano1 = getIsHubNano1(state);

    const checkExtraAttributeAvailibility = (group, type, definition): boolean => {
        const existingEventsUsingThisType = extendedForm[group].filter(event => event.type === type).length;
        if (!definition.devices) {
            return existingEventsUsingThisType === 0;
        }
        // $FlowFixMe
        const devices = listDevicesForActionAttribute(state, {
            types: definition.devices
        });
        return devices.length > existingEventsUsingThisType;
    };

    const allowedTypes = ['while', 'then'].reduce(
        (acc, group) => ({
            ...acc,
            [group]: eventsByGroup(state, { group, templateId: extendedForm.template.id }).map(event => {
                const definition = getAttributeDefinition(event.type, region);
                return {
                    available: checkExtraAttributeAvailibility(group, event.type, definition),
                    event,
                    icon: definition.icon,
                    label: definition.text
                };
            })
        }),
        {}
    );

    const prepareActionEvent = curry((state, props) => newActionEvent(state, props));

    return {
        allowedTypes: { ...allowedTypes }, // I know it's weird, but go ask flow
        extendedForm,
        isNano1,
        prepareActionEvent: prepareActionEvent(state)
    };
};

const mapDispatchToProps = {
    addActionAttribute,
    removeActionAttribute,
    setActionAttribute,
    setActionForm
};

const mergeProps = ({ prepareActionEvent, ...restStateProps }, dispatchProps, { form, ...restOwnProps }) => {
    const { addActionAttribute, removeActionAttribute, setActionAttribute, setActionForm } = dispatchProps;

    return {
        ...restOwnProps,
        ...restStateProps,
        addActionAttribute: flowRight(addActionAttribute, prepareActionEvent),
        removeActionAttribute,
        setActionAttribute,
        setActionForm: (propertyName: string, newValue: any) => setActionForm({ propertyName, newValue })
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(Component);



// WEBPACK FOOTER //
// ./src/components/widgets/actions/entry/action-detail/index.js